import { createContext } from 'react';

const ResourceListContext = /*#__PURE__*/createContext({});

export { ResourceListContext };
